export default "__VITE_ASSET__BVHdClgx__"